import {Navigate, Outlet, useLocation} from "react-router";
import {useAuth} from "../contexts/AuthContext";
import {PATHS} from "./paths";
import {RouteLoader} from "./RouteLoader";
import {allowsAuthenticated} from "./guestRoutePolicy";

/**
 * Layout-гард лендинга: живую сессию сразу уводим в приложение.
 * Если сессию восстановить не удалось (токены протухли), остаёмся на лендинге —
 * там откроется форма входа с сообщением (useLandingHelpers).
 */
export function GuestRoute() {
    const {isAuthenticated, loading} = useAuth();
    const location = useLocation();

    if (loading) return <RouteLoader/>;

    if (isAuthenticated && !allowsAuthenticated(location.pathname, location.search)) {
        return <Navigate to={PATHS.app} replace/>;
    }

    return <Outlet/>;
}
